import { render } from "./TraspasoCreate.vue?vue&type=template&id=7d40b993&scoped=true"
import script from "./TraspasoCreate.vue?vue&type=script&lang=js"
export * from "./TraspasoCreate.vue?vue&type=script&lang=js"

import "./TraspasoCreate.vue?vue&type=style&index=0&id=7d40b993&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d40b993"]])

export default __exports__